module.exports = __webpack_public_path__ + "img/bg_principal.8f39f457.svg";